import _ from "lodash";
import React, { useState } from "react";
import classes from "./RemoveItemsModal.scss";
import { AssessmentIllustration } from "@toddle-edu/ds-theme";
import PropTypes from "prop-types";
import { Tag, Modal, Button } from "@toddle-edu/ds-web";
import classNames from "classnames";

const RemoveItemsModal = props => {
  const {
    items,
    onClickButton1,
    onClickButton2,
    buttonText1,
    buttonText2,
    modalTitle,
    noItemsText,
    noItemsSubText,
    setRemovedItemsList,
    modalDescription,
  } = props;

  const [itemsList, setItemslist] = useState(items);
  const onRemoveItem = item => {
    const newItemsList = _.filter(itemsList, itemObj => itemObj.id !== item.id);
    setItemslist(newItemsList);
    setRemovedItemsList(prevList => [...prevList, item]);
  };
  const isButton2Disabled = _.isEmpty(items);

  return (
    <Modal width="480px" height="600px" onClose={onClickButton1}>
      <Modal.Header>{modalTitle}</Modal.Header>
      <Modal.Body>
        <div className={classNames("text-body-1", classes.modalDescription)}>
          {modalDescription}
        </div>
        {_.isEmpty(items) ? (
          <div className={classes.emptyTagsContainer}>
            <div className={classes.emptyTagsIcon}>
              <img
                src={AssessmentIllustration}
                width={"152px"}
                height={"128px"}
                alt=""
              />
            </div>
            <div className={classes.emptyTagsTextContainer}>
              <div className={classes.emptyTagsTextHeader}>{noItemsText}</div>
              <div className={classes.emptyTagsTextDescription}>
                {noItemsSubText}
              </div>
            </div>
          </div>
        ) : (
          <div className={classes.tagsContainer}>
            <div className={classes.selectedTagsContainer}>
              {_.map(itemsList, item => {
                return (
                  <Tag size={"small"} onClose={() => onRemoveItem(item)}>
                    {item.label}
                  </Tag>
                );
              })}
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.footerContainer}>
          <Button
            variant="outlined-subtle"
            size="large"
            onClick={onClickButton1}
          >
            {buttonText1}
          </Button>
          <Button
            variant="primary"
            size="large"
            onClick={onClickButton2}
            disabled={isButton2Disabled}
          >
            {buttonText2}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

RemoveItemsModal.defaultProps = {
  buttonText1: "Cancel",
  buttonText2: "Save",
  modalTitle: "Remove Items",
  noItemsText: "No items created yet",
  noItemsSubText: "Go ahead and create your first item",
  modalDescription:
    "Please note that this is a cumulative list of items added to the selected standards. Removing an item will remove it from all the standards they are added to.",
};
RemoveItemsModal.propTypes = {
  buttonText1: PropTypes.string,
  buttonText2: PropTypes.string,
  modalTitle: PropTypes.string,
  noItemsText: PropTypes.string,
  noItemsSubText: PropTypes.string,
  items: PropTypes.array,
  onClickButton1: PropTypes.func,
  onClickButton2: PropTypes.func,
  setRemovedItemsList: PropTypes.func,
  modalDescription: PropTypes.string,
};
export default RemoveItemsModal;
